import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/hooks";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import ThemeProvider from "../../hooks/themeProvider";
import _ from "lodash";
import { library } from "../../redux/library/action";
import { countries } from "../../redux/countries/action";
import { states } from "../../redux/states/action";
import { cmsSettings } from "../../redux/cmsSettings/action";
import DSAPAgencyLogin from "../../pages/auth/ixe-login";
import Settings from "../../components/management/Settings";
import IxeLogin from "../../pages/auth/ixe-login";

const LoginLayout = () => {
	let navigate = useNavigate()
	const dispatch = useAppDispatch()
	const [color, setColor] = useState('universal')
	const [favicon, setFavicon] = useState()
	const [isDeferredApiCallsCompleted, setIsDeferredApiCallsCompleted] = useState<boolean>(false);
	const result = useSelector(selectCurrent)
	const { height, width } = useWindowDimensions();
	const { header, footer, visible, sidebar, theme, favIcon, isGuestTokenReady, isThemeAvailable, tenantId } = result

	const deferredAPICalls = () => {
		if (isGuestTokenReady) {
			dispatch(library.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`, entity: 'library', options: { authorization_required: false } }))
			dispatch(countries.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`, entity: 'countries', options: { authorization_required: false } }))
			dispatch(states.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`, entity: 'states', options: { authorization_required: false } }))
			dispatch(cmsSettings.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`, entity: 'cmsSettings', jsonData: {}, options: { authorization_required: false } }))
			setIsDeferredApiCallsCompleted(true); // this assumes the api calls will be successfull. Have to check for errors before preventing reload
		}
	}

	useEffect(() => {
		if (isGuestTokenReady  && !isDeferredApiCallsCompleted) {
			deferredAPICalls();
		}
	}, [isGuestTokenReady]);


	useEffect(() => {
		if (!favicon) return;

		let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

		if (!link) {
			link = document.createElement("link");
			link.rel = "icon";
			document.head.appendChild(link);
		}

		link.href = favicon;
	}, [favicon]);

	useEffect(() => {
		setColor(theme)
		setFavicon(favIcon)
	}, [theme]);

	
	return (
		<>
			<ThemeProvider>
				{width && width < 720 ? (
					//  Start - Mobile View
					<>
						
					</>
					//  End - Mobile View
				) : width && width >= 720 && width < 1024 ? (
					//  Start - Tablet View
					<>
						
					</>
					//  End - Tablet View
				) : (
					//  Start - Web View 
					<div className="leading-normal tracking-normal bg-primary" id="main-body">
						<div className="flex flex-wrap sm:hide">
							{visible ? <Settings /> : <></>}
						<IxeLogin/>
						</div>
					</div>
					//  End - Web View 
				)}
			</ThemeProvider>
		</>
	)
}
export default LoginLayout;